import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import { GetLeadRequest, GetLeadResponse, LeadDataRequest, LeadDataResponse, GetLeadsConfigRequest, GetLeadsConfigResponse, SetLeadsConfigRequest, SetLeadsConfigResponse } from "../../models/Lead.model";

const API_URL = environment.apiUrl;
export const getLeadData = createAsyncThunk<
  LeadDataResponse,
  LeadDataRequest,
  { rejectValue: string }
>("leads/GetDataLead", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Lead/GetDataLead`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: LeadDataResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch milestones");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
export const getLeads = createAsyncThunk<
  GetLeadResponse,
  GetLeadRequest,
  { rejectValue: string }
>("leads/getAllLeads", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Lead/GetLeads`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetLeadResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch milestones");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const getLeadsConfig = createAsyncThunk<
  GetLeadsConfigResponse,
  GetLeadsConfigRequest,
  { rejectValue: string }
>("leads/getLeadsConfig", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Lead/GetLeadsConfig`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetLeadsConfigResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch leads config");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

export const setLeadsConfig = createAsyncThunk<
  SetLeadsConfigResponse,
  SetLeadsConfigRequest,
  { rejectValue: string }
>("leads/setLeadsConfig", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_URL}Lead/SetLeadsConfig`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: SetLeadsConfigResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to set leads config");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});